import { InputTextComponent } from './input-text.component';

export default angular
  .module('sfMobile.components.input-text', [])
  .component('sfInputText', InputTextComponent).name;
